import React from 'react';
import { observer } from 'mobx-react-lite';
import { getBooleanFF } from '@atlaskit/platform-feature-flags';
import { debounce } from '../../../jira-common/utils';
import { toSelectOption } from '../../models/SelectOption';
import { QuestionStore, toChoiceQuestionAnswerOrEmpty } from '../../stores/QuestionStore';
import { DisplayMode } from '../RenderForm';
import { EditDropdown } from './edit/EditDropdown';
import { ViewDropdown } from './view/ViewDropdown';
export const Dropdown = observer(({
  id,
  questionStore,
  formStore,
  displayMode
}) => {
  var _questionStore$issueF;
  const availableOptions = questionStore.availableOptions();
  const currentAnswer = toChoiceQuestionAnswerOrEmpty(questionStore.currentAnswer);
  const currentOption = questionStore.getAnswerChoicesAsObjects()[0];
  const currentChoiceId = currentOption === null || currentOption === void 0 ? void 0 : currentOption.value;
  const hasOtherChoice = !!questionStore.otherChoiceId;
  const showEditComponent = displayMode === DisplayMode.Edit && !(getBooleanFF('platform.proforma-read-only-questions.wewrsr') && questionStore.formQuestion.readOnly) && !((_questionStore$issueF = questionStore.issueFieldData) !== null && _questionStore$issueF !== void 0 && _questionStore$issueF.readOnlyReason);
  if (showEditComponent) {
    const onChange = value => {
      const selectedChoiceId = value === null || value === void 0 ? void 0 : value.value;
      const newChoiceIds = selectedChoiceId ? [selectedChoiceId] : [];
      questionStore.setAnswer({
        text: hasOtherChoice && selectedChoiceId === questionStore.otherChoiceId ? toChoiceQuestionAnswerOrEmpty(questionStore.currentAnswer).text : '',
        choices: newChoiceIds,
        choiceObjects: value ? [QuestionStore.optionToChoice(value)] : []
      });
    };
    const otherChoiceSelected = hasOtherChoice && currentChoiceId === questionStore.otherChoiceId;
    const loadChoicesAsync = questionStore.isAsyncChoicesField ? debounce((inputValue, callback) => {
      formStore.loadChoicesAsync(questionStore.id, inputValue).then(_ => callback(questionStore.choices.map(toSelectOption)));
    }, 500) : undefined;
    const onOtherChoiceTextChange = event => {
      questionStore.setAnswer({
        text: event.target.value,
        choices: toChoiceQuestionAnswerOrEmpty(questionStore.currentAnswer).choices
      });
    };
    return /*#__PURE__*/React.createElement(EditDropdown, {
      id: id,
      key: `${id}-${questionStore.dependentFieldChangedCount}`,
      options: availableOptions,
      value: currentOption,
      loading: questionStore.loading,
      loadOptions: loadChoicesAsync,
      onChange: onChange,
      hasOtherOption: hasOtherChoice,
      otherOptionSelected: otherChoiceSelected,
      otherOptionText: currentAnswer.text,
      onOtherOptionTextChange: onOtherChoiceTextChange,
      isInvalid: !!questionStore.validationErrors
    });
  }
  return /*#__PURE__*/React.createElement(ViewDropdown, {
    id: id,
    options: availableOptions,
    value: currentOption,
    hasOtherOption: hasOtherChoice,
    otherOptionText: currentAnswer.text,
    displayMode: displayMode
  });
});